import {
  NavItemPrimaryInterface,
  NavItemSecondaryInterface,
} from "app/app-layout/models";

import { NavItemsActions, NavItemsActionType } from "./actions";
import { NavItemsState, NavItemsStateInterface } from "./models";

const initialState: NavItemsStateInterface = new NavItemsState({});

export function navItemsReducer(
  state: NavItemsStateInterface = initialState,
  action: NavItemsActions,
): NavItemsState {
  switch (action.type) {
    case NavItemsActionType.ResetNavItems:
    case NavItemsActionType.LoadNavItemsFailed:
      return {
        ...state,
        primaryNavItems: undefined,
        secondaryNavItems: undefined,
      };

    case NavItemsActionType.LoadNavItems:
      return state;

    case NavItemsActionType.LoadNavItemsCompleted:
      const primaries: NavItemPrimaryInterface[] =
        action.payload as NavItemPrimaryInterface[];
      const secondaries: { [categoryId: string]: NavItemSecondaryInterface[] } =
        {};

      for (const item of primaries) {
        secondaries[item.categoryId] = item.menuItems;
      }

      return {
        ...state,
        primaryNavItems: primaries,
        secondaryNavItems: secondaries,
      };

    default:
      return state;
  }
}
